import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { match } from 'ts-pattern';
import Text from '../../text';
import Icon from '../../icon';
import SingleSelect from '../components/singleSelect';
import MultiSelect from '../components/multiSelect';
import InlineSelect from '../components/inlineSelect';
import Range from '../components/range';
import Boolean from '../components/boolean';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const renderControl = (filterDefinition, elmId, onChange, value) => {
    const controlType = filterDefinition.controlType;
    return match(controlType)
        .with('singleSelect', () => (_jsx(SingleSelect, { value: value, onChange: onChange, elmId: elmId, definition: filterDefinition })))
        .with('multiSelect', () => (_jsx(MultiSelect, { value: value, onChange: onChange, elmId: elmId, definition: filterDefinition })))
        .with('inlineSelect', () => (_jsx(InlineSelect, { value: value, onChange: onChange, elmId: elmId, definition: filterDefinition })))
        .with('range', () => (_jsx(Range, { value: value, onChange: onChange, elmId: elmId, definition: filterDefinition })))
        .with('boolean', () => (_jsx(Boolean, { value: value, onChange: onChange, elmId: elmId, definition: filterDefinition })))
        .otherwise(() => {
        throw new Error('Invalid control type');
    });
};
const Label = ({ description, label, labelIconProps, noMargin, }) => (_jsxs("div", { className: cx('label-and-description', { 'no-margin-label': noMargin }), children: [_jsxs("div", { className: cx('label-container'), children: [typeof labelIconProps?.name === 'string' && (_jsx(Icon, { fitted: true, iconStyle: 'regular', size: 'medium', ...labelIconProps })), _jsx(Text.Body, { size: 'large', weight: 'heavy', className: cx('filter-label'), children: label && label })] }), description && (_jsx(Text, { color: 'gray', size: 'tiny', className: cx('description'), children: description }))] }));
const SingleFilterLayout = ({ displayTitle = true, elmId = 'filter_control', filterDefinition, value, onChange, }) => {
    return (_jsxs("div", { "data-elm-id": elmId, className: cx('filter-layout', {
            half: filterDefinition.styleIntent?.width === 'half' &&
                filterDefinition.controlType === 'range',
        }), children: [filterDefinition.controlType !== 'boolean' && displayTitle && (_jsx(Label, { ...filterDefinition })), _jsx("div", { className: cx('single-filter'), children: renderControl(filterDefinition, elmId, onChange, value) })] }));
};
const FilterGroupLayout = ({ elmId = 'filter_panel', groupDefinition, groupData, onChange, height, }) => {
    const onChangeFilter = (key, newValue) => {
        onChange(key, newValue);
    };
    return (_jsx("div", { "data-elm-id": elmId, className: cx('layout', { 'full-height': height === 'max' }), children: _jsx("div", { className: cx('filter-layout-items', {
                compact: groupDefinition.styleIntent?.compact,
            }), children: groupDefinition.items.map((item, index) => {
                if (item.itemType === 'filter') {
                    const filterDefinition = item;
                    const name = filterDefinition.name;
                    return (_jsx(SingleFilterLayout, { displayTitle: filterDefinition.styleIntent?.displayTitle, filterDefinition: filterDefinition, value: groupData[name], onChange: onChangeFilter }, index));
                }
                else if (item.itemType === 'section') {
                    const sectionDefinition = item;
                    return (_jsxs("div", { className: cx('section', {
                            compact: sectionDefinition.styleIntent?.compact,
                            split: sectionDefinition.styleIntent?.twoColumns === 'all',
                            'desktop-split': sectionDefinition.styleIntent?.twoColumns ===
                                'desktop-only',
                        }), children: [sectionDefinition.label && (_jsx(Label, { ...sectionDefinition, noMargin: !!sectionDefinition.styleIntent?.twoColumns })), sectionDefinition.filters.map((item, index) => {
                                const filterDefinition = item;
                                const name = filterDefinition.name;
                                return (_jsx(SingleFilterLayout, { filterDefinition: filterDefinition, value: groupData[name], onChange: onChangeFilter }, index));
                            }), sectionDefinition.styleIntent?.showDivider &&
                                !sectionDefinition.label &&
                                !sectionDefinition.description && (_jsx("hr", { className: cx('divider') }))] }, index));
                }
                else {
                    throw new Error(`Invalid group item type: ${groupDefinition.itemType}.  Expected 'filter' or 'section'.`);
                }
            }) }) }));
};
export default FilterGroupLayout;
//# sourceMappingURL=index.js.map